import { buildSelector } from '@/shared/lib/store';

export const [useIsAppDataLoading] = buildSelector(
    (state) => state.appData.status === 'loading',
);
